export default __webpack_public_path__ + "c9cf93a0a57d9034fcb62d467d922d50.png";